function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 61 61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "#BA3D3E",
    d: "M0 30.5C0 47.343 13.658 61 30.5 61S61 47.343 61 30.5 47.342 0 30.5 0C13.657 0 0 13.658 0 30.5Zm1.8 1.315v-2.63h27.385V26.15H2.084l.332-1.587.218-1.042h.02c2.46-9.813 10.07-17.73 19.784-20.573v-.02l.983-.248h.005l1.637-.417v16.064H17.09v-2.63h5.343V5.7C14.173 8.39 7.694 15.15 5.368 23.52H29.18V1.8h2.63v21.72h23.812C53.296 15.15 46.817 8.389 38.557 5.7v9.997H43.9v2.629h-7.973V2.262l1.637.417h.005l.988.248v.02C48.27 5.789 55.885 13.707 58.34 23.52h.02l.218 1.042.332 1.587H31.81v3.036h27.384v2.63H31.81v3.036H58.91l-.332 1.587-.218 1.042h-.02c-2.46 9.813-10.07 17.73-19.784 20.573v.02l-.988.248h-.005l-1.637.417V42.674H43.9v2.63h-5.343V55.3c8.26-2.689 14.739-9.45 17.065-17.82H31.81V59.2h-2.63V37.48H5.368c2.326 8.37 8.806 15.131 17.066 17.82v-9.996H17.09v-2.63h7.973v16.064l-1.637-.417h-.005l-.983-.248v-.02C12.725 55.211 5.11 47.293 2.654 37.48h-.02l-.218-1.042-.332-1.587h27.101v-3.036H1.801Z",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeal);
export default __webpack_public_path__ + "static/media/seal.54ecc29abcbe0f6038a308e21afd2f82.svg";
export { ForwardRef as ReactComponent };